module.exports = __webpack_public_path__ + "img/EscudoColombia.6e98cfde.png";